import { handleSearchRedirects } from './searchResultsLoader';

const searchResultsLoader = async ({ request }) =>
  handleSearchRedirects(request);

export default searchResultsLoader;
